import React from "react";
import { StyledHero } from "./Hero.styled";
import { Button } from "../Button/Button.styled";
import { WhiteButton } from "../Button/Button.styled";
import { Flex } from "../Flex/Flex.styled";
import {FaLinkedin} from "react-icons/fa"

const Hero = () => {
  return (
    <StyledHero id="about">
      <h1>Hi there! i'm ibukunoluwa, a Front-end Developer.</h1>
      <section>
        <p>
          <strong>
            "I craft solid and scalable front-end products with great user
            experiences."
          </strong>
          , Using frontend technologies such as React,Javascript,NextJS. I am
          also open to collaborating with people and learning new technologies.
          {/* Available for Contract & Full-time Roles. */}
        </p>
      </section>
      <Flex>
        <a href = "#contact">
          <Button>Contact Me</Button>
        </a>
        <a
          href="https://www.linkedin.com/in/ibukunoluwa-akintobi-65262323a/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <WhiteButton>
            <FaLinkedin size={15} />
            <p>Linkedin</p>
          </WhiteButton>
        </a>
      </Flex>
    </StyledHero>
  );
};

export default Hero;
